var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#layers';
                    var viewUrl = 'svg/icons.svg#view-layers';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };